module.exports = __webpack_public_path__ + "media/TRX_Signing_Ceremony_HSBC_June_2017.1aebf8c7.mp4";